import { useTranslation } from 'react-i18next';
import '@/ui/bootstrapJs';

import { ChatUserType, EmergencySituationInstructions } from '@/signalr';
import type { NewChatMessageBody } from '@/signalr';
import { FaIcon } from '@/ui';
import { sendNewChatMessage } from './chatApi';

export type EmergencyInstructionsDropdownProps = {
  incidentId: string;
  disabled: boolean;
};

const INSTRUCTION_ITEMS: {
  instructions: EmergencySituationInstructions;
  buttonTextKey: string;
  smsTextKey: string;
}[] = [
  {
    instructions: EmergencySituationInstructions.Cpr,
    buttonTextKey: 'Chat_SendCprInstructions_ButtonTitle',
    smsTextKey: 'Chat_CprEmergencySituationInstructions_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.Choking,
    buttonTextKey: 'Chat_SendChokingInstructions_ButtonTitle',
    smsTextKey: 'Chat_ChokingEmergencySituationInstructions_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.ChildChoking,
    buttonTextKey: 'Chat_SendChildChokingtructions_ButtonTitle',
    smsTextKey: 'Chat_ChildChokingEmergencySituationInstructions_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.GpsInstructionsIos,
    buttonTextKey: 'Chat_SendLocationInstructionsIos_ButtonTitle',
    smsTextKey: 'Chat_GpsInstructionsIos_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.GpsInstructionsAndroid,
    buttonTextKey: 'Chat_SendLocationInstructionsAndroid_ButtonTitle',
    smsTextKey: 'Chat_GpsInstructionsAndroid_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.CameraInstructionsIos,
    buttonTextKey: 'Chat_SendCameraInstructionsIos_ButtonTile',
    smsTextKey: 'Chat_CameraInstructionsIos_SmsText',
  },
  {
    instructions: EmergencySituationInstructions.CameraInstructionsAndroid,
    buttonTextKey: 'Chat_SendCameraInstructionsAndroid_ButtonTile',
    smsTextKey: 'Chat_CameraInstructionsAndroid_SmsText',
  },
];

export function EmergencyInstructionsDropdown({ incidentId, disabled }: EmergencyInstructionsDropdownProps) {
  const { t } = useTranslation();

  const sendInstructions = async (item: (typeof INSTRUCTION_ITEMS)[number]) => {
    const body: NewChatMessageBody = {
      message: t(item.smsTextKey),
      emergencySituationInstructions: item.instructions,
      attachment: null,
      senderType: ChatUserType.Dispatcher,
    };
    await sendNewChatMessage(incidentId, body);
  };

  return (
    <div className="dropup">
      <button
        className="btn btn-light btn-sm dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        disabled={disabled}
      >
        <FaIcon icon="fal fa-location-crosshairs" />
      </button>
      <ul className="dropdown-menu shadow">
        {INSTRUCTION_ITEMS.map((item) => (
          <li key={item.instructions}>
            <button type="button" className="dropdown-item px-2" onClick={() => void sendInstructions(item)}>
              <FaIcon icon="fal fa-paper-plane-top" />
              <span className="ms-1">{t(item.buttonTextKey)}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
